import {
  RIGHT_SIDEBAR_DEFAULT,
  RIGHT_SIDEBAR_MAX,
  RIGHT_SIDEBAR_MIN,
} from "@/features/project/types";

const STORAGE_KEY = "right-panel-width";
const WIDTH_CHANGE_EVENT = "df:right-panel-width-change";

export function clampRightPanelWidth(width: number) {
  return Math.min(RIGHT_SIDEBAR_MAX, Math.max(RIGHT_SIDEBAR_MIN, Math.round(width)));
}

export function readStoredRightPanelWidth() {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (!saved) return null;
    const parsed = Number.parseInt(saved, 10);
    if (Number.isNaN(parsed)) return null;
    return clampRightPanelWidth(parsed);
  } catch {
    return null;
  }
}

export function resolveRightPanelWidth(defaultWidth?: number) {
  const storedWidth = readStoredRightPanelWidth();
  if (storedWidth !== null) {
    return storedWidth;
  }

  return clampRightPanelWidth(defaultWidth ?? RIGHT_SIDEBAR_DEFAULT);
}

export function saveRightPanelWidth(width: number) {
  const clamped = clampRightPanelWidth(width);
  try {
    localStorage.setItem(STORAGE_KEY, String(clamped));
  } catch {
    // localStorage unavailable
  }
}

export function emitRightPanelWidthChange(width: number) {
  window.dispatchEvent(
    new CustomEvent<number>(WIDTH_CHANGE_EVENT, {
      detail: clampRightPanelWidth(width),
    })
  );
}

export function subscribeRightPanelWidthChange(handler: (width: number) => void) {
  const listener = (event: Event) => {
    const custom = event as CustomEvent<number>;
    handler(clampRightPanelWidth(custom.detail));
  };

  window.addEventListener(WIDTH_CHANGE_EVENT, listener as EventListener);
  return () => window.removeEventListener(WIDTH_CHANGE_EVENT, listener as EventListener);
}
